import React from 'react';

export default function SectionDots({ total, active, goTo }) {
  return (
    <div className="section-dots">
      {Array.from({ length: total }, (_, i) => (
        <button
          key={i}
          className={`section-dot${i === active ? ' is-active' : ''}`}
          onClick={() => goTo(i)}
          aria-label={`Section ${i + 1}`}
        />
      ))}
    </div>
  );
}
